// extracted by mini-css-extract-plugin
export default {"customElementContainer":"a2sxlD"};